import gsap from "gsap";

//************************************
// Menu
//************************************

$('#menu-main-menu .menu-item a').addClass('menu-trigger');
$('.menu-trigger').click(function () {
    $('#menu-trigger').toggleClass('clicked');
    $('.menu-type').toggleClass('open');
    $('body').toggleClass('overflow-hidden');
});


//************************************
// MAIN NAV
//************************************
function initDropdownToggle() {

    $.each($(".menu-item"), function (index, element) {
        let subMenu = $(element).children('ul'),
            tl;
        let sub_menu_items = subMenu.children('li');

        if (subMenu.length != 0) {
            tl = gsap.timeline({paused: true});

            tl.from(subMenu, .3, {
                height: 0
            });

            tl.from(sub_menu_items, .5, {
                opacity: 0
            },'-=0.3');

            element.subMenuAnimation = tl;

            $(element).hover(menuItemOver, menuItemOut);
        }
    });

    function menuItemOver() {
        this.subMenuAnimation.play();
    }

    function menuItemOut() {
        this.subMenuAnimation.reverse();
    }
}

initDropdownToggle();

//wpml
jQuery(document).ready(function($) {
    function addLanguageNames() {

    }

    // Initial call
    addLanguageNames();

    // Reapply when the dropdown changes
    $('.wpml-ls-item').on('click', function() {
        setTimeout(addLanguageNames, 100); // Adjust timeout as needed
    });
});
